/* eslint-disable no-undef */
APP.utils = {};

APP.utils.getClientOs = function () {
  var c = Client.detect();
  var os = c.operatingSystem.name.toLowerCase().replace(' ', '-');

  return os || '';
};

APP.utils.getClientOsClass = function () {
  var os = this.getClientOs();

  return APP.conf.mobileOSConv[os] || '';
};

APP.utils.getClientBrowser = function () {
  var c = Client.detect();
  var b = c.browser.name.toLowerCase();

  return b || '';
};
